/*global require */
'use strict';
var angular = require('angular');
var lodash = require('lodash');
var tinygradient = require('tinygradient');

var app = angular.module('app');

var STORE_COLOR = '#e8cdb2';
var STORE_COLOR_HOVER = '#dbb595';
var STORE_COLOR_ACTIVE = '#d81e04';

var RESTAURANT_COLOR = '#f29c62';
var RESTAURANT_COLOR_HOVER = '#f37e20';
var RESTAURANT_COLOR_ACTIVE = '#d81e04';

var PARKING_COLOR = '#d1d1d1';

var ROOM_COLOR = '#efefef';

var STROKE_COLOR = '#a3a3a3';

const centerMapTemplate = require('./center-map.template.pug');

import { duration } from '../lib/const';
import { pushTrackingData } from '../lib/dataLayer';
import { click, getUrlParamByName, mq, each, scrollTo, debounce2, compareStrings } from '../lib/util';
import './vendor/maplabel';

/*global window, document */
function CenterMapController($scope, Context, Map, Modal, $compile, $timeout, Scroll, $attrs, $window) {
    var vm = this;

    if ($attrs.featuredStores) {
        vm.featuredStores = $attrs.featuredStores.split(',');
    }

    vm.search = {
        name: '',
        category: '',
        type: ''
    };

    vm.tabletBreakpoint = 'sm';

    vm.showControls = false;
    vm.showLevelsMenu = true;
    vm.showParkingOverlay = false;
    vm.parkingOverlayTriggered = false;
    vm.dataParkingArea = {};

    //start in store mode
    vm.isParkingMode = true;

    //parking initially disabled
    vm.isParkingEnabled = true;

    vm.filteredStores = [];
    vm.filteredParkingAreas = [];
    vm.selectedStoreId;

    getData(Context.settings.center.id);



    function getData(center) {
        Map.get(center).then(function (response) {

            try {
                vm.mapData = response.data;
                //enable parking if any parking lots contain capacity data

                //if parking status, scale the occupied percentages exponentially,
                //so that it more accurately represents the ease of finding a space
                lodash.each(vm.mapData.parkingAreas, function(area) {
                    if (area.status) {
                        area.status.percentOccupied = Math.floor((area.status.percentOccupied * area.status.percentOccupied) / 100);
                    }
                });


                mapInit();

                vm.categories = lodash.chain(vm.mapData.stores).map('categories').flatten().uniq().sort().value();
                vm.availableAmenities = lodash.chain(vm.mapData.amenities).map('type').uniq().sort().value();
                vm.filterStores();
                vm.map.filterPolygons();
                var params = getUrlVars();
                if(params.id != null){
                    vm.showLocationOnMap(params.id);
                }

            } catch (err) {
                console.error(err);
            }
        });
    }

    //Initialize green to red gradient for parking
    var colors = [
        { color: '#0d9b3f', pos: 0.0 },
        { color: '#22a03a', pos: 0.06 },
        { color: '#3ba833', pos: 0.12 },
        { color: '#c4cd0e', pos: 0.36 },
        { color: '#eacd05', pos: 0.44 },
        { color: '#ffcd00', pos: 0.51 },
        { color: '#ffc000', pos: 0.58 },
        { color: '#ffac00', pos: 0.64 },
        { color: '#fd570c', pos: 0.85 },
        { color: '#f53f10', pos: 0.92 },
        { color: '#f12b13', pos: 1.0 }
    ];

    var gradient = tinygradient(colors);
    var stops = gradient.rgb(101); //allows for percent 0 - 100%

    vm.getGradientColor = function(percent) {
        return stops[percent].toRgbString();
    }

    vm.hasAmenity = function (type) {
        if (!vm.availableAmenities) {
            return false;
        }

        return vm.availableAmenities.indexOf(type) !== -1;
    };

    vm.openParkingOverlay = function() {
        //only open on first click
        if (!vm.parkingOverlayTriggered) {
            vm.showParkingOverlay = true;
            vm.parkingOverlayTriggered = true;

            $timeout(function() {
                vm.closeParkingOverlay();
            }, 10000);
        }
    };

    vm.closeParkingOverlay = function() {
        vm.showParkingOverlay = false;
    };

    vm.openControls = function () {
        const controls = document.querySelector('.map__controls');
        vm.showControls = true;

        if(!mq(vm.tabletBreakpoint)) {
            const controlsOffsetY = controls.getBoundingClientRect().top + window.pageYOffset;
            scrollTo(document.scrollingElement, controlsOffsetY, duration)
        }
    };

    vm.closeControls = function () {
        vm.showControls = false;

        if(!mq(vm.tabletBreakpoint)) {
            scrollTo(document.scrollingElement, 0, duration)
        }else{

        }
    };

    vm.changeFloor = function (floor) {
        if (floor === vm.currentFloor) {
            return;
        }

        vm.search.name = '';
        vm.search.category = '';

        vm.ensureFloorVisible(floor);
    };

    vm.ensureFloorVisible = function (floor) {
        vm.currentFloor = floor;
        vm.map.hideInfowindow();
        vm.map.filterPolygons();
        vm.clearAmenity();
    };

    vm.selectStore = function (store) {
        var id = store.id;
        var floor = store.floors[0].level;

        vm.ensureFloorVisible(floor);
        vm.map.zoomToNum(id, floor);
        vm.map.showInfowindow(id, floor);
        vm.closeControls();
        vm.selectedStoreId = id;

        pushTrackingData({            
            'name': 'vendor_click',
            'retailer_name': store.displayName
        });
    };

    vm.selectParking = function(area) {
        vm.map.settings.map.fitBounds(area.floors[1].latLngBounds);
        vm.map.showParkingWindow(area.id, 1);
        vm.closeControls();
    };

    vm.filterStores = function () {

        //Check if store data has loaded yet
        if (!vm.mapData) {
            return;
        }

        var stores = vm.mapData.stores;

        //name filter
        stores = lodash.filter(stores, function (store) {

            if (vm.search.name && vm.search.name.length > 0) {
                if (!store.displayName && !store.sortName) {
                    return false;
                }

                var storeSearchName =  store.displayName && store.displayName.length > 0 ? store.displayName : store.sortName;

                return storeSearchName.toLowerCase().indexOf(vm.search.name.toLowerCase()) !== -1;
            }

            return true;
        });

        //category filter
        stores = lodash.filter(stores, function (store) {
            if (vm.search.category && vm.search.category.length > 0) {
                return lodash.indexOf(store.categories, vm.search.category) !== -1;
            }

            return true;
        });

        // featured stores filter
        if (vm.featuredStores) {
            stores = lodash.filter(stores, function (store) {
                return vm.featuredStores.indexOf(store.id.toString()) !== -1;
            });
        }

        var isFiltered = vm.search.name.length > 0 || (vm.search.category && vm.search.category.length > 0) || vm.featuredStores !== undefined;

        if (isFiltered) {
            //If filters are applied, we want to try to switch to the correct floor

            //Get a list of all floors represented by the current list of stores
            var floors = lodash.chain(stores).flatMap(function (n) {
                return lodash.map(n.floors, 'level');
            }).uniq().value();

            //If there are only stores on a single floor, then switch to that floor
            if (floors.length === 1 && floors[0] !== vm.currentFloor) {
                vm.ensureFloorVisible(floors[0]);
            }

            //If there are multiple floors represented then choose the main floor
            if (floors.length > 1) {
                if (vm.numOfFloors === 3 && vm.currentFloor !== 2) {
                    vm.ensureFloorVisible(2);
                } else if (vm.numOfFloors === 2 && vm.currentFloor !== 1) {
                    vm.ensureFloorVisible(1);
                }
            }
        }

        vm.map.filter(lodash.map(stores, 'id'), isFiltered);

        vm.filteredStores = stores;
    };

    vm.getStoreListStyles = function() {
        const topEl = document.querySelector('.map__controls__top');
        const controlsEl = document.querySelector('.map__controls');
        const styles = getComputedStyle(controlsEl);

        let maxHeight = window.innerHeight -
            topEl.offsetHeight -
            parseInt(styles.paddingTop) -
            parseInt(styles.paddingBottom);

        if(mq(vm.tabletBreakpoint)) {
            const headerEl = document.querySelector('.layout__header');
            maxHeight -= headerEl.offsetHeight;
        }

        return {
            'max-height': `${maxHeight}px`
        }
        // }else{
        //     return {
        //         'max-height': 'none'
        //     };
        // }
    }

    vm.storeModalButtonClick = function(eventName, storeName, url) {
        pushTrackingData({
            'name': eventName,
            'retailer_name': storeName
        });

        $window.location.href = url;
    }

    vm.setAmenity = function(type) {
        vm.map.hideAmenities();
        vm.currentAmenity = type;
        vm.map.showAmenity(type, vm.currentFloor);
    };

    vm.clearAmenity = function() {
        vm.currentAmenity = '';
        vm.map.hideAmenities();
    };

    vm.clearSearch = function() {
        vm.search.name = null;
        document.querySelector('#title').focus();
    }

    vm.toggleAmenity = function (type) {

        //close info window
        vm.map.hideInfowindow();

        //zoom map to show all stores
        vm.map.zoomToAll();

        //toggle off
        if (vm.currentAmenity === type) {
            vm.clearAmenity();
            return;
        }

        pushTrackingData({
            'name': 'amenities_click',
            'amenity': type
        });

        //toggle on
        vm.setAmenity(type);
    };

    vm.animateAmenities = function() {
        lodash.each(vm.map.amenities, function(amenity) {
            if (amenity.marker.getVisible()) {
                amenity.marker.setAnimation(google.maps.Animation.BOUNCE);

                setTimeout(function() {
                    amenity.marker.setAnimation(null);
                }, 2800);

            }
        });
    };

    vm.setFocus = function(index, isFocused) {
        vm.map.setFocus(index, isFocused);
    };

    vm.setParkingMode = function() {

        //Bail if we are already in the desired mode
        if (vm.isParkingMode) {
            return;
        }

        //Set status
        vm.isParkingMode = true;

        //loop through each parking area and set the fill color based on capacity
        lodash.each(vm.map.parkingAreas,
            function(area) {

                if (area.status) {

                    Object.getOwnPropertyNames(area.floors)
                        .forEach(function(floor) {
                            area.floors[floor].polyline.set('fillColor',
                                vm.getGradientColor(area.status.percentOccupied));
                        });
                }
            });

        //loop through each store and set the fill color to greyscale
        lodash.each(vm.map.data,
            function(item) {

                var fillColor = item.type === 'store' ? '#cdcdcd' : '#aaa';

                Object.getOwnPropertyNames(item.floors)
                    .forEach(function(floor) {
                        item.floors[floor].polyline.set('fillColor', fillColor);
                    });

            });

        //Close any open info windows
        vm.map.hideInfowindow();

        //Switch amenity to valet parking
        vm.setAmenity('Valet Parking');

        //Change amenity color
        lodash.forEach(vm.map.amenities,
            function(amenity) {
                if (amenity.type === 'Valet Parking') {
                    amenity.marker.icon.url = '/images/map-amenities/key-alt.png';
                }
            });

        //Zoom out to show all stores
        vm.map.zoomToAll();
    };

    vm.setStoreMode = function() {

        //Bail if we are already in the desired mode
        if (!vm.isParkingMode) {
            return;
        }

        //Set status
        vm.isParkingMode = false;

        //loop through each parking area and set the fill color to default
        lodash.each(vm.map.parkingAreas, function(area) {

            Object.getOwnPropertyNames(area.floors).forEach(function(floor) {
                area.floors[floor].polyline.set('fillColor', PARKING_COLOR);
            });
        });

        //loop through each store and set the fill color to default
        lodash.each(vm.map.data, function(item) {

            var fillColor = item.type === 'store' ? STORE_COLOR : RESTAURANT_COLOR;

            Object.getOwnPropertyNames(item.floors).forEach(function(floor) {
                item.floors[floor].polyline.set('fillColor', fillColor);
            });

        });

        //Close any open parking info windows
        vm.map.hideInfowindow();

        //Reset amenity color
        vm.clearAmenity();

        lodash.forEach(vm.map.amenities, function(amenity) {
            if (amenity.type === 'Valet Parking') {
                amenity.marker.icon.url = '/images/map-amenities/key.png';
            }
        });

        //Zoom out to show all stores
        vm.map.zoomToAll();
    };

    vm.showLocationOnMap = function(id){
        var stores = vm.mapData.stores;
        var store = lodash.filter(stores, function(store){
            return store.id == id;
        });
        if(store != null && store.length > 0){
            var selectedStore = store[0];
            $timeout(function(){
                vm.selectStore(selectedStore);
            }, 50);
        } else { //parking
            if (!vm.isParkingMode) {
                vm.setParkingMode();
            }

            var parkingArea = vm.dataParkingArea[id];
            vm.map.fitToRegion(parkingArea);
            vm.map.showParkingWindow(id, 1);
            vm.closeControls();
        }
    }

    $scope.$watch('vm.search.category', function (newVal, oldVal) {
        if (newVal !== oldVal) {

            // in case category is reset check if it isn't an empty string.
            if (newVal.length > 0) {
                pushTrackingData({
                    'name': 'map_cat_click',
                    'map_category': newVal
                });
            }
            
            //Reset the search box when the category changes
            vm.search.name = '';
            vm.filterStores();

            //Hide any popup windows
            if (vm.map) {
                vm.map.hideInfowindow();
            }

            //Close controls window
            vm.closeControls();
        }
    });

    $scope.$watch('vm.search.name', function (newVal, oldVal) {
        if (newVal !== oldVal) {
            //Hide any popup windows
            if (vm.map) {
                vm.map.hideInfowindow();
            }

            vm.filterStores();
        }
    });

    /* MallMap Constructor */
    //TODO: Pull MallMap out into it's own file or incorporate into controller

    function MallMap(settings) {
        this.settings = lodash.assignIn({
            map: null
        }, settings);
    }

    MallMap.buildLatLngArray = function (pointsArray) {
        var result = [],
            i;
        for (i = 0; i < pointsArray.length; i += 1) {
            result.push(new google.maps.LatLng(pointsArray[i][0], pointsArray[i][1]));
        }
        return result;
    };

    MallMap.getBounds = function (latLngArray) {
        var result,
            i;
        result = new google.maps.LatLngBounds();
        for (i = 0; i < latLngArray.length; i += 1) {
            result.extend(latLngArray[i]);
        }
        return result;
    };

    MallMap.prototype.bindClick = function (key, level) {
        var that = this;
        google.maps.event.addListener(this.data[key].floors[level].polyline, 'click', function () {
            $scope.$apply(function () {
                that.zoomToNum(key, level);
                that.showInfowindow(key, level);
                vm.closeControls();
            });
        });
    };

    MallMap.prototype.bindHover = function (key, level) {
        var that = this;
        google.maps.event.addListener(this.data[key].floors[level].polyline, 'mouseover', function () {
            that.setHover(key, true, level);
        });
        google.maps.event.addListener(this.data[key].floors[level].polyline, 'mouseout', function () {
            that.setHover(key, false, level);
        });
    };

    MallMap.prototype.showInfowindow = function (num, floor) {
        var that = this;

        if (this.infowindow === undefined) {
            this.infowindow = new google.maps.InfoWindow({
                content: "",
                maxWidth: 300,
                zIndex: 21
            });

            google.maps.event.addListener(this.infowindow, 'closeclick', function() {
                vm.selectedStoreId = null;
                that.hideInfowindow();
            });
        }

        this.infowindow.setPosition(this.data[num].floors[floor].latLngCenter);

        var scope = $scope.$new(true);
        var store = this.data[num];

        scope.store = store;
        scope.storeModalButtonClick = vm.storeModalButtonClick;
        scope.storeOfferUrl = `https://www.retailtherapyapp.com/offers/?center=irvine-spectrum-center&store=${encodeURIComponent(store.title)}`

        var template = '<div class=map__info ng-data-title={{store.title}}><div class=map__info__heading>{{store.title}}</div><div class=map__info__properties><span class=status>{{store.status}}</span>Suite {{store.suite}}<br>{{store.phone}}</div><div class=map__info__body ng-bind-html=store.description></div><div class=map__button__container><button class="button--transparent map__button__detail" target="_blank" ng-class="{\'full-width\': store.offers.length === 0}" ng-click="storeModalButtonClick(\'select_store\', store.title, store.url)">MORE DETAILS</button><button class="button--transparent map__button__special"  ng-click="storeModalButtonClick(\'select_store_offers\', store.title, storeOfferUrl)" ng-show="store.offers.length > 0">OFFER</button></div></div>';
        var element = $compile(template)(scope);

        //Needs to run in Angular context
        $timeout(function () {
            that.infowindow.setContent(element[0]);
            that.infowindow.open(that.settings.map);
            vm.showLevelsMenu = false;
        });
    };

    MallMap.prototype.showParkingWindow = function (num, floor) {
        var that = this;
        var area;
        if (that.parkingAreas[num] != null) {
            area = that.parkingAreas[num];
        } else {
            area = lodash.filter(that.parkingAreas, function(area) {
                return area.id == num;
            })[0];
        }

        //No availability for this parking area
        if (!area.status) {
            return;
        }

        if (this.infowindow === undefined) {
            this.infowindow = new google.maps.InfoWindow({
                content: "",
                maxWidth: 300,
                zIndex: 21
            });

            google.maps.event.addListener(this.infowindow, 'closeclick', function() {
                that.hideInfowindow();
            });
        }

        this.infowindow.setPosition(area.floors[floor].latLngCenter);

        var scope = $scope.$new(true);

        scope.area = area;
        scope.settings = Context.settings;

        scope.findValet = function() {

            //Ensure valet amenity is set
            if (vm.currentAmenity !== 'Valet Parking') {
                vm.setAmenity('Valet Parking');
            }

            //close info window
            vm.map.hideInfowindow();

            //zoom map to show all stores
            vm.map.zoomToAll();

            //delay till the zoom is complete, then animate the markers
            google.maps.event.addListenerOnce(that.settings.map, 'idle', function () {
                that.settings.map.panBy(1, 1); //DO NOT REMOVE.  Fixes issue where after zooming and animating the markers no longer show
                vm.animateAmenities();
            });
        };

        var template = '<div class="map__info map__info--parking"><div class="map__info__heading">{{area.name}} Availability</div><div class="map__info__body"><div class="parking-key"><div class="parking-key-scrubber" ng-style="{left: area.status.percentOccupied + \'%\'}"></div></div><div class="parking-key-labels"><span>OPEN</span><span>MODERATE</span><span>FULL</span></div></div><div class="map__button__container"><a target="_blank" ng-href="https://www.google.com/maps/dir//{{area.floors[1].latLngCenter.lat()}},{{area.floors[1].latLngCenter.lng()}}/@{{area.floors[1].latLngCenter.lat()}},{{area.floors[1].latLngCenter.lng()}},18z/" class="button--transparent map__button__detail full-width">GET DIRECTIONS</a><a href="" ng-click="findValet()" ng-show="area.status.percentOccupied >= 75" class="button--transparent map__button__detail full-width">FIND VALET PARKING</a></div>';
        var element = $compile(template)(scope);

        //Needs to run in Angular context
        $timeout(function () {
            that.infowindow.setContent(element[0]);
            that.infowindow.open(that.settings.map);
            vm.showLevelsMenu = false;
        });
    };

    MallMap.prototype.showAmenityWindow = function (num) {

        //only show popup window if we are in parking mode
        if (!vm.isParkingMode) {
            return;
        }

        var that = this;

        var amenity = that.amenities[num];

        if (this.infowindow === undefined) {
            this.infowindow = new google.maps.InfoWindow({
                content: "",
                maxWidth: 300,
                zIndex: 21
            });

            google.maps.event.addListener(this.infowindow, 'closeclick', function() {
                that.hideInfowindow();
            });
        }

        this.infowindow.setPosition(amenity.marker.position);

        var scope = $scope.$new(true);

        scope.amenity = amenity;
        scope.settings = Context.settings;

        var template = '<div class="map__info map__info--parking"><div class="map__info__heading">{{amenity.type}}</div><div class="map__info__body" ng-bind-html="amenity.description"></div><div class="map__button__container"><a target="_blank" ng-href="https://www.google.com/maps/dir//{{amenity.marker.position.lat()}},{{amenity.marker.position.lng()}}/@{{amenity.marker.position.lat()}},{{amenity.marker.position.lng()}},18z/" class="button--transparent map__button__detail full-width">GET DIRECTIONS</a></div>';
        var element = $compile(template)(scope);

        //Needs to run in Angular context
        $timeout(function () {
            that.infowindow.setContent(element[0]);
            that.infowindow.open(that.settings.map);
            vm.showLevelsMenu = false;
        });
    };

    MallMap.prototype.hideInfowindow = function() {
        var that = this;

        if (!this.infowindow) {
            return;
        }

        $timeout(function() {
            that.infowindow.close();
            vm.showLevelsMenu = true;
        });
    };

    MallMap.prototype.buildStores = function (json) {
        var zindex,
            self = this;

        self.data = {};

        json.stores.forEach(function (store) {

            //alias
            var dataSuite = self.data[store.id] = {};

            if (store.type === "store") {
                dataSuite.color = STORE_COLOR;
            } else if (store.type === "restaurant") {
                dataSuite.color = RESTAURANT_COLOR;
            } else {
                dataSuite.color = ROOM_COLOR;
            }

            /* higher z-index to sub-stores */
            // if (store.suite.match(/[a-zA-Z]+/)) {
            //     zindex = 3;
            // } else {
            //     zindex = 2;
            // }
            zindex = 3;

            //lower z-index for stores that have no label e.g. they share a polygon with another store
            if (store.hideLabelFromMap) {
                zindex = 1;
            }

            dataSuite.category = store.categories;
            dataSuite.description = store.shortDescription && store.shortDescription.length > 0 ? store.shortDescription : store.description;
            dataSuite.num = store.id;
            dataSuite.title = store.hideLabelFromMap ? '' : store.alternateLabel ? store.alternateLabel : store.displayName;
            dataSuite.logo = store.logo;
            dataSuite.name = json.center.name;
            dataSuite.address = json.center.address;
            dataSuite.phone = store.phone;
            dataSuite.type = store.type;
            dataSuite.offers = store.offers;
            dataSuite.url = store.url;
            dataSuite.baseZIndex = zindex;
            dataSuite.suite = store.suite;
            dataSuite.status = store.status;

            dataSuite.floors = {};

            store.floors.forEach(function (floor) {

                //alias
                var dataFloor = dataSuite.floors[floor.level] = {};

                dataFloor.points = floor.coordinates[0];
                dataFloor.level = floor.level;
                dataFloor.latLngArray = MallMap.buildLatLngArray(dataFloor.points);
                dataFloor.latLngBounds = MallMap.getBounds(dataFloor.latLngArray);
                dataFloor.latLngCenter = dataFloor.latLngBounds.getCenter();
                dataFloor.polyline = new google.maps.Polygon({
                    clickable: true,
                    draggable: false,
                    editable: false,
                    fillColor: dataSuite.color,
                    optimized: false,
                    strokeColor: STROKE_COLOR,
                    strokeWeight: 1,
                    fillOpacity: 1,
                    zIndex: zindex
                });

                //Create a label if needed
                if (dataSuite.title.length > 0) {
                    let minZoom = store.minZoom !== undefined && 0 !== parseInt(store.minZoom) ? store.minZoom : 18;
                    dataFloor.maplabel = new MapLabel({
                        map: self.settings.map,
                        minZoom: minZoom,
                        optimized: false,
                        position: dataFloor.latLngCenter,
                        text: dataSuite.title,
                        floor: floor.level,
                        angleOverride: store.angleOverride,
                        fontSizeOverride: store.fontSizeOverride,
                        polygon: dataFloor.latLngArray,
                        strokeColor: 'transparent',
                        zIndex: 20
                    });
                }

                dataFloor.polyline.setPath(dataFloor.latLngArray);
                dataFloor.polyline.setMap(self.settings.map);

                if (!store.hideLabelFromMap) {
                    self.bindHover(store.id, floor.level);
                    self.bindClick(store.id, floor.level);
                }
            });
        });

        //Get current bounds
        var bounds = new google.maps.LatLngBounds();

        lodash.forEach(self.data, function (store) {
            bounds.union(lodash.values(store.floors)[0].latLngBounds);
        });

        vm.currentBounds = bounds;
    };


    MallMap.prototype.buildParkingAreas = function (json) {
        var self = this;

        this.parkingAreas = {};

        json.parkingAreas.forEach(function (parkingArea, i) {

            //alias
            var dataParkingArea = self.parkingAreas[i] = {};

            dataParkingArea.id = parkingArea.id;
            dataParkingArea.color = PARKING_COLOR;
            dataParkingArea.name = parkingArea.name;
            dataParkingArea.title = parkingArea.label;
            dataParkingArea.status = parkingArea.status;
            dataParkingArea.floors = {};

            parkingArea.floors.forEach(function (floor) {

                //alias
                var dataFloor = dataParkingArea.floors[floor.level] = {};

                dataFloor.points = floor.coordinates[0];
                dataFloor.level = floor.level;
                dataFloor.latLngArray = MallMap.buildLatLngArray(dataFloor.points);
                dataFloor.latLngBounds = MallMap.getBounds(dataFloor.latLngArray);
                dataFloor.latLngCenter = dataFloor.latLngBounds.getCenter();
                dataFloor.polyline = new google.maps.Polygon({
                    clickable: true,
                    draggable: false,
                    editable: false,
                    fillColor: vm.featuredStores ? dataParkingArea.color : parkingArea.status ? vm.getGradientColor(parkingArea.status.percentOccupied) : dataParkingArea.color,
                    fillOpacity: 1,
                    optimized: false,
                    strokeColor: STROKE_COLOR,
                    strokeWeight: 1,
                    zIndex: 2
                });

                //Create label if needed
                if (dataParkingArea.title.length > 0) {
                    dataFloor.maplabel = new MapLabel({
                        map: self.settings.map,
                        minZoom: 16,
                        optimized: false,
                        position: dataFloor.latLngCenter,
                        text: dataParkingArea.title,
                        floor: floor.level,
                        polygon: dataFloor.latLngArray,
                        strokeColor: 'transparent',
                        zIndex: 20
                    });
                }

                dataFloor.polyline.setPath(dataFloor.latLngArray);
                dataFloor.polyline.setMap(self.settings.map);
                if (vm.dataParkingArea[dataParkingArea.id] == null) {
                    vm.dataParkingArea[dataParkingArea.id] = dataFloor.latLngBounds;
                }

                google.maps.event.addListener(dataFloor.polyline, 'click', function () {

                    $scope.$apply(function () {

                        //Switch to parking mode
                        if (!vm.isParkingMode) {
                            vm.setParkingMode();
                        }


                        self.settings.map.fitBounds(dataFloor.latLngBounds);
                        self.showParkingWindow(i, floor.level);
                        vm.closeControls();
                    });
                });
            });
        });

        //Get current bounds

        lodash.forEach(self.parkingAreas, function (parking) {
            vm.currentBounds.union(lodash.values(parking.floors)[0].latLngBounds);
        });

        //Get filtered list of only parking areas with occupied status
        vm.filteredParkingAreas = lodash.filter(self.parkingAreas, 'status');
    };

    /* Build map rooms */
    MallMap.prototype.buildRooms = function (json) {
        var self = this;

        self.rooms = {};

        json.rooms.forEach(function(room, i) {

            //alias
            var dataRoom = self.rooms[i] = {};

            dataRoom.color = ROOM_COLOR;
            dataRoom.title = room.label;
            dataRoom.floors = {};

            room.floors.forEach(function(floor) {

                //alias
                var dataFloor = dataRoom.floors[floor.level] = {};

                dataFloor.points = floor.coordinates[0];
                dataFloor.level = floor.level;
                dataFloor.latLngArray = MallMap.buildLatLngArray(dataFloor.points);
                dataFloor.latLngBounds = MallMap.getBounds(dataFloor.latLngArray);
                dataFloor.latLngCenter = dataFloor.latLngBounds.getCenter();
                dataFloor.polyline = new google.maps.Polygon({
                    clickable: true,
                    draggable: false,
                    editable: false,
                    fillColor: dataRoom.color,
                    fillOpacity: 1,
                    optimized: false,
                    strokeColor: STROKE_COLOR,
                    strokeWeight: 1,
                    zIndex: 2
                });

                //Create label if needed
                if (dataRoom.title.length > 0) {
                    dataFloor.maplabel = new MapLabel({
                        map: self.settings.map,
                        minZoom: 18,
                        optimized: false,
                        position: dataFloor.latLngCenter,
                        text: dataRoom.title,
                        floor: floor.level,
                        polygon: dataFloor.latLngArray,
                        strokeColor: 'transparent',
                        zIndex: 20
                    });
                }

                dataFloor.polyline.setPath(dataFloor.latLngArray);
                dataFloor.polyline.setMap(self.settings.map);
            });
        });
    };

    /* Build map vacant suites */
    MallMap.prototype.buildVacant = function (json) {
        var self = this;

        var debugLabels = false;

        self.vacant = {};

        json.vacant.forEach(function (suite, i) {

            self.vacant[i] = {};
            self.vacant[i].color = ROOM_COLOR;
            self.vacant[i].title = suite.label;
            self.vacant[i].floors = {};

            suite.floors.forEach(function (level) {
                self.vacant[i].floors[level] = {};
                self.vacant[i].floors[level].points = level.coordinates[0];
                self.vacant[i].floors[level].level = level.level;
                self.vacant[i].floors[level].latLngArray = MallMap.buildLatLngArray(self.vacant[i].floors[level].points);
                self.vacant[i].floors[level].latLngBounds = MallMap.getBounds(self.vacant[i].floors[level].latLngArray);
                self.vacant[i].floors[level].latLngCenter = self.vacant[i].floors[level].latLngBounds.getCenter();
                self.vacant[i].floors[level].polyline = new google.maps.Polygon({
                    clickable: true,
                    draggable: false,
                    editable: false,
                    fillColor: self.vacant[i].color,
                    fillOpacity: 1,
                    optimized: false,
                    strokeColor: STROKE_COLOR,
                    strokeWeight: 1,
                    zIndex: 2
                });

                if (debugLabels) {
                    self.vacant[i].floors[level].maplabel = new MapLabel({
                        map: self.settings.map,
                        minZoom: 18,
                        optimized: false,
                        position: self.vacant[i].floors[level].latLngCenter,
                        text: self.vacant[i].title,
                        floor: level.level,
                        polygon: self.vacant[i].floors[level].latLngArray,
                        strokeColor: 'transparent',
                        zIndex: 20
                    });
                }

                self.vacant[i].floors[level].polyline.setPath(self.vacant[i].floors[level].latLngArray);
                self.vacant[i].floors[level].polyline.setMap(self.settings.map);
            });
        })
    };

    MallMap.prototype.redraw = function () {
        var map = this.settings.map;
        google.maps.event.trigger(map, 'resize');
        map.setZoom(map.getZoom());
    };

    MallMap.prototype.showAmenity = function (type, floor) {
        var self = this;

        self.amenities.forEach(function (amenity) {

            if (amenity.type === type && amenity.level === floor) {
                amenity.active = true;
                amenity.marker.setMap(self.settings.map);
            } else {
                amenity.active = false;
                amenity.marker.setMap(null);
            }
        });
    };

    MallMap.prototype.hideAmenities = function () {
        var self = this;

        self.amenities.forEach(function (amenity) {
            amenity.active = false;
            amenity.marker.setMap(null);
        });
    };

    /* Build map amenities */
    MallMap.prototype.buildAmenities = function (data) {

        var self = this,
            path = '/assets/images/map-amenities/',
            imageMap = {
                'Restroom': path + 'bathroom.png',
                'ATM': path + 'atm.png',
                'Elevator': path + 'elevator.png',
                'Escalator': path + 'escalator.png',
                'Guest Services': path + 'information.png',
                'Car Charging Station': path + 'plug.png',
                'Attractions': path + 'star.png',
                'Trolley Pick Up': path + 'trolley.png',
                'WiFi': path + 'wifi.png',
                'Valet Parking': path + 'key.png',
                'Kids Play Area': path + 'playarea.png',
                'Curbside2Go': path + 'curbside2.png',
                'Bicycle Rack': path + 'bike.png',
                'Carousel': path + 'carousel.png',
                'Ferris Wheel': path + 'ferris-wheel.png',
                'Security': path + 'security.png',
                'Train': path + 'train.png',
                'Entry Point': path + 'door.png'
            };

        self.amenities = [];

        data.amenities.forEach(function (amenity, i) {

            var item = {};

            item.title = amenity.type;
            item.type = amenity.type;
            item.level = amenity.level;
            item.description = amenity.description;

            // Custom numbered icons for the entryways.
            let iconUrl = imageMap[amenity.type];
            const isEntryPoint = true,
                num = amenity.amenityNumber,
                hasValidNum = !!(num && num.length > 0),
                parsedNum = parseInt(num, 10),
                numInRange = hasValidNum && parsedNum >= 1 && parsedNum <= 20;
            if (isEntryPoint && hasValidNum && numInRange) {
                iconUrl = path + 'entry' + parsedNum.toString() + '.png';
            }

            const icon = {
                url: String(iconUrl),
                scaledSize: new google.maps.Size(50, 75),
                origin: new google.maps.Point(0, 0),
                anchor: new google.maps.Point(25, 70)
            };

            item.marker = new google.maps.Marker({
                position: { lat: amenity.latitude, lng: amenity.longitude },
                map: null,
                icon: icon,
            });

            //Add popup windows for valet parking
            if (item.type === 'Valet Parking') {
                item.marker.addListener('click', function () {

                    $scope.$apply(function () {
                        self.showAmenityWindow(i, amenity.level);
                        vm.closeControls();
                    });
                });
            }

            self.amenities.push(item);
        });
    };

    MallMap.prototype.setActive = function (index, isActive) {
        var self = this;

        if (isActive !== false) {
            isActive = true;
        }
        if (this.data[index] !== undefined) {

            this.data[index].isActive = isActive;

            Object.getOwnPropertyNames(this.data[index].floors).forEach(function (prop) {

                self.setFill(index, false, self.data[index].floors[prop].level);
            });
        }
    };

    MallMap.prototype.setFocus = function (index, isFocused) {
        var self = this;

        if (isFocused !== false) {
            isFocused = true;
        }
        if (this.data[index] !== undefined) {

            this.data[index].isFocused = isFocused;

            Object.getOwnPropertyNames(this.data[index].floors).forEach(function (prop) {
                self.setFill(index, false, self.data[index].floors[prop].level);
            });
        }
    };

    MallMap.prototype.setHover = function (index, isHover, level) {
        if (isHover !== false) {
            isHover = true;
        }
        if (this.data[index] !== undefined) {
            if (this.data[index].floors[level].polyline !== undefined) {
                if (isHover) {
                    this.setFill(index, true, level);
                } else {
                    this.setFill(index, false, level);
                }
            }
        }

        let element = document.querySelector('.store__list a.hover');
        if(element) {
            element.classList.remove('hover');
        }

        if (isHover) {
            element = document.querySelector('.store__list a[data-num="' + index + '"]');
            if(element) {
                element.classList.add('hover');
            }
        }
    };


    /* Set fill of polygons on hover/active etc */
    MallMap.prototype.setFill = function (index, hover, level) {

        var zIndex;


        if (this.data[index] !== undefined && this.data[index].floors[level].polyline !== undefined && this.data[index].type !== undefined) {

            if (this.data[index].type === 'restaurant') {

                if (hover) {
                    this.data[index].floors[level].polyline.set('fillColor', RESTAURANT_COLOR_HOVER);
                } else if (this.data[index].isActive || this.data[index].isFocused) {
                    this.data[index].floors[level].polyline.set('fillColor', RESTAURANT_COLOR_ACTIVE);
                    //increase z-index to make visible (might be shared polygon)
                    zIndex = this.data[index].baseZIndex + 3;
                    this.data[index].floors[level].polyline.set('zIndex', zIndex);
                } else {
                    this.data[index].floors[level].polyline.set('fillColor', RESTAURANT_COLOR);
                    //decrease z-index to default
                    zIndex = this.data[index].baseZIndex;
                    this.data[index].floors[level].polyline.set('zIndex', zIndex);
                }
            }

            if (this.data[index].type === 'store') {

                if (hover) {
                    this.data[index].floors[level].polyline.set('fillColor', STORE_COLOR_HOVER);
                } else if (this.data[index].isActive || this.data[index].isFocused) {
                    this.data[index].floors[level].polyline.set('fillColor', STORE_COLOR_ACTIVE);
                    //increase z-index to make visible (might be shared polygon)
                    zIndex = this.data[index].baseZIndex + 3;
                    this.data[index].floors[level].polyline.set('zIndex', zIndex);
                } else {
                    this.data[index].floors[level].polyline.set('fillColor', STORE_COLOR);
                    //decrease z-index to default
                    zIndex = this.data[index].baseZIndex;
                    this.data[index].floors[level].polyline.set('zIndex', zIndex);
                }
            }
        }
    };

    /* Zoom to num when a store is clicked */
    MallMap.prototype.zoomToNum = function (num, floor) {
        if (this.data[num] !== undefined) {
            this.settings.map.fitBounds(this.data[num].floors[floor].latLngBounds);
        }
    };

    MallMap.prototype.filter = function (stores, filtered) {

        var key,
            bounds = new google.maps.LatLngBounds();

        this.allStores = !filtered;

        for (key in this.data) {
            if (this.data.hasOwnProperty(key)) {

                if (lodash.indexOf(stores, parseInt(key)) !== -1) {

                    if (filtered) {
                        this.setActive(key, true);
                    } else {
                        this.setActive(key, false);
                    }

                    bounds.union(lodash.values(this.data[key].floors)[0].latLngBounds);
                } else {
                    this.setActive(key, false);
                }
            }
        }

        //Don't fit bounds if the store list is empty, or we end up in the ocean
        if (stores.length) {
            // this.settings.map.fitBounds(bounds);
        }
    };

    /* Zoom map to show all stores */
    MallMap.prototype.zoomToAll = function() {

        var key,
            bounds = new google.maps.LatLngBounds();

        for (key in this.data) {
            if (this.data.hasOwnProperty(key)) {
                bounds.union(lodash.values(this.data[key].floors)[0].latLngBounds);
            }
        }

        this.settings.map.fitBounds(bounds);
    }

    MallMap.prototype.fitToRegion = function(bounds) {
        this.settings.map.fitBounds(bounds);
    }

    /* Hides and Shows polygons depending on floor level / type */
    MallMap.prototype.changePolygonVisibility = function (data, type) {

        var that = this,
            key;

        for (key in data) {
            Object.getOwnPropertyNames(data[key].floors).forEach(function (prop) {

                /* Include type in filter */
                if (type) {
                    if (data[key].floors[prop].level === vm.currentFloor && data[key].type === type) {
                        data[key].floors[prop].polyline.setMap(that.settings.map);
                        data[key].floors[prop].maplabel.set('map', that.settings.map);

                    } else {
                        data[key].floors[prop].polyline.setMap(null);
                        data[key].floors[prop].maplabel.set('map', null);
                    }

                /* Just filter by level */
                } else {
                    if (data[key].floors[prop].level === vm.currentFloor) {
                        data[key].floors[prop].polyline.setMap(that.settings.map);
                        if (data[key].floors[prop].maplabel) {
                            data[key].floors[prop].maplabel.set('map', that.settings.map);
                        }
                    } else {
                        data[key].floors[prop].polyline.setMap(null);
                        if (data[key].floors[prop].maplabel) {
                            data[key].floors[prop].maplabel.set('map', null);
                        }
                    }
                }
            });
        }
    };

    /* Filter all types of polygons */
    MallMap.prototype.filterPolygons = function (type) {
        this.changePolygonVisibility(this.data, type);
        this.changePolygonVisibility(this.parkingAreas);
        this.changePolygonVisibility(this.rooms);
        this.changePolygonVisibility(this.vacant);
    };

    MallMap.prototype.bind = function () {
        var that = this;

        const storeLinks = document.querySelectorAll('#stores a');

        // TODO may need to make this live
        each(storeLinks, (link) => {
            link.addEventListener('mouseover', (e) => {
                var key = link.getAttribute('data-num');
                var floor = link.getAttribute('data-floor');

                that.setHover(key, true, floor);
            });

            link.addEventListener('mouseout', (e) => {
                var key = link.getAttribute('data-num');
                var floor = link.getAttribute('data-floor');

                that.setHover(key, false, floor);
            });
        });


        setTimeout(function () {
            /* initalise focus on suite from previous page */
            var suite = getUrlParamByName('suite');
            var amenity = getUrlParamByName('amenity');

            if (suite) {
                const element = document.querySelector("[data-num~='" + suite + "']");
                click(element);
            }

            if (amenity)
            {
                const elements = document.querySelectorAll(".map_amenities__wrapper [data-type]");

                each(elements, function(element) {
                    if (compareStrings(element.dataset.type, amenity)) {
                        click(element);
                    }
                });
            }
        }, 250);
    };

    MallMap.prototype.init = function () {
        var that = this;

        that.buildStores(vm.mapData);
        that.buildParkingAreas(vm.mapData);
        that.buildRooms(vm.mapData);
        that.buildVacant(vm.mapData);
        that.buildAmenities(vm.mapData);
        that.bind();

        //Get the number of floors
        vm.numOfFloors = lodash.chain(that.data).flatMap(function (n) {
            return lodash.map(n.floors, 'level');
        }).max().value();

        //if more than two floors, set current floor to "main"
        vm.currentFloor = vm.numOfFloors > 2 ? 2 : 1;
    };

    function mapInit() {
        var mapOptions,
            map,
            mallMap;


        mapOptions = {
            center: {
                lat: 33.6503406,
                lng: -117.7434357
            },
            draggableCursor: 'default',
            minZoom: 16,
            maxZoom: 20,
            mapTypeControl: false,
            styles: [
                {
                    "stylers": [
                        { "visibility": "off" }
                    ]
                },
                {
                    "featureType": "water",
                    "stylers": [
                        { "visibility": "on" }
                    ]
                },
                {
                    "featureType": "road",
                    "stylers": [
                        { "visibility": "on" }
                    ]
                },
                {
                    "elementType":"labels",
                    "stylers":[
                        {
                            "visibility":"off"
                        }
                    ]
                },
                {
                    "featureType":"road",
                    "elementType":"labels",
                    "stylers":[
                        {
                            "visibility":"on"
                        }
                    ]
                },
            ],
            zoom: 17,
            zoomControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            streetViewControlOptions: {
                position: google.maps.ControlPosition.LEFT_TOP
            },
            fullscreenControl: false
        };


        map = new google.maps.Map(
            document.getElementById('map-canvas'),
            mapOptions
        );


        //Keep map within center bounds
        map.addListener('center_changed', function () {
            if (vm.currentBounds.contains(map.getCenter())) {
                vm.lastValidCenter = map.getCenter();
                return;
            }
            map.setCenter(vm.lastValidCenter);
        });

        mallMap = new MallMap({
            'map': map
        });

        // Redraw map when height changes
        onDocumentHeightChange(function () {
            mallMap.redraw();
        });

        mallMap.init();

        vm.map = mallMap;
    }

    function getUrlVars() {
        let vars = {};
        const parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, (m,key,value) => {
            vars[key] = value;
        });
        return vars;
    }

    /**
     * Fire Callback when document height changes
     *
     * @param callback
     */
    function onDocumentHeightChange(callback) {
        var lastHeight = document.body.offsetHeight;

        function run() {
            var newHeight = document.body.offsetHeight;

            if (newHeight !== lastHeight) {
                callback();
                lastHeight = newHeight;
            }
        }

        window.setInterval(run, 500);
    }

    // $timeout(function() {

    //     if (mq('md', 'max-width')) {
    //         scrollTo(document.querySelector('#map-canvas'), 2000);
    //     }

    // }, 500);

    //Prevent mobile devices scrolling when dragging over map labels
    vm.preventScrolling = false;

    window.addEventListener('touchstart', (e) => {
        if (e.target.classList.contains('map-label')) {
            vm.preventScrolling = true;
        }
    });

    window.addEventListener('touchstart', (e) => {
        vm.preventScrolling = false;

    });
    window.addEventListener('touchstart', (e) => {
        if (vm.preventScrolling) {
            e.preventDefault();
        }
    })
}

app.directive('centerMap', function () {
    return {
        restrict: 'E',
        replace: true,
        template: centerMapTemplate(),

        controller: CenterMapController,
        controllerAs: 'vm',
        bindToController: true,

        scope: {}
    };
});
